/**
 * @class AppVideoDialog
 * @param element HTMLElement
 * @constructor
 */
function AppVideoDialog(element){
	this._element = element;
	this._document = element.ownerDocument;
	this._window = this._document.defaultView;

	this._focusHandlerBound = this._focusHandler.bind(this);
	this._keydownHandlerBound = this._keydownHandler.bind(this);
	this._closeButtonClickHandlerBound = this._closeButtonClickHandler.bind(this);

	this._element.setAttribute("role", "dialog");
	this._element.setAttribute("aria-labelledby", "video-title");
	this._content = this._element.getElementsByClassName("app_video-content")[0];
	this._iframe = this._content.getElementsByTagName("IFRAME")[0];
	// Save source
	this._iframeSrc = this._iframe.src;
	// Kill content until modal opened
	this._iframe.src = "";

	this._element.insertAdjacentHTML("afterbegin", "<div class=\"app_video-backdrop\"></div>");
	this._element.getElementsByClassName("app_video-backdrop")[0].addEventListener("click", this._closeButtonClickHandlerBound, false);
	this._content.insertAdjacentHTML("beforeend", "<button class=\"app_video-close\"><span class=\"app_video-close-label\">Close</span><span class=\"app_video-close-decoration\"></span></button>");
	this._closeButton = this._content.getElementsByClassName("app_video-close")[0];
	this._closeButton.addEventListener("click", this._closeButtonClickHandlerBound, false);
}

Object.defineProperty(AppVideoDialog.prototype, "element", {
	/** @this {AppVideoDialog} */
	get: function getElement(){
		return this._element;
	}
});

/** @type DocumentView */
AppVideoDialog.prototype._window = null;
/** @type HTMLDocument */
AppVideoDialog.prototype._document = null;
/** @type HTMLElement */
AppVideoDialog.prototype._element = null;
/** @type HTMLElement */
AppVideoDialog.prototype._content = null;
/** @type Boolean */
AppVideoDialog.prototype._opened = false;
/** @type HTMLElement */
AppVideoDialog.prototype._closeButton = null;
/** @type HTMLElement */
AppVideoDialog.prototype._iframe = null;
/** @type String */
AppVideoDialog.prototype._iframeSrc = null;
AppVideoDialog.prototype._focusHandlerBound = null;
AppVideoDialog.prototype._keydownHandlerBound = null;
AppVideoDialog.prototype._closeButtonClickHandlerBound = null;
AppVideoDialog.prototype._lastActiveElement = null;

AppVideoDialog.prototype.open = function open(){
	if(this._opened){
		return;
	}

	this._iframe.src = this._iframeSrc;
	this._opened = true;
	this._document.body.classList.add("body--modal");
	this._element.classList.add("app_video--opened");
	// Save previous active element
	this._lastActiveElement = this._document.activeElement;
	// Focusable
	this._element.tabIndex = -1;
	this._element.focus();

	this._document.addEventListener("focus", this._focusHandlerBound, true);
	this._document.addEventListener("keydown", this._keydownHandlerBound, true);
};

// If focus lost outside dialog
AppVideoDialog.prototype._focusHandler = function _focusHandler(event){
	if (!this._element.contains(event.target)) {
		event.stopPropagation();
		this._element.focus();
	}
};

AppVideoDialog.prototype._keydownHandler = function _keydownHandler(event){
	if (event.keyCode == 27) {
		this.close();
	}
};

AppVideoDialog.prototype.close = function close(){
	if(!this._opened){
		return;
	}

	this._document.removeEventListener("focus", this._focusHandlerBound, true);
	this._document.removeEventListener("keydown", this._keydownHandlerBound, true);

	this._opened = false;
	this._document.body.classList.remove("body--modal");
	this._element.classList.remove("app_video--opened");
	// TODO Async remove content
	// Kill content
	this._iframe.src = "";
	// Remove focusable
	this._element.removeAttribute("tabindex");
	this._lastActiveElement.focus();
	this._lastActiveElement = null;
};

/**
 *
 * @param {MouseEvent} event
 * @private
 */
AppVideoDialog.prototype._closeButtonClickHandler = function _closeButtonClickHandler(event){
	event.preventDefault();
	this.close();
};

AppVideoDialog.prototype.clear = function clear(){
	this._document.removeEventListener("focus", this._focusHandlerBound, true);
	this._document.removeEventListener("keydown", this._keydownHandlerBound, true);
	this._element.getElementsByClassName("app_video-backdrop")[0].removeEventListener("click", this._closeButtonClickHandlerBound, false);
	this._closeButton.removeEventListener("click", this._closeButtonClickHandlerBound, false);

	return true;
};